import React, { useState } from "react";
import Images from "../images";
import  { useEffect} from "react";
import { Link } from "react-router-dom";

const MedEngageSummit2021 = () => {

  const [selectedMember, setSelectedMember] = useState(null);
 useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
     useEffect(() => {
                document.title = "Summit 2021 - MedEngage";
              }, []);
const teamMembers = [
  {
    name: "Dr. T. P. Lahane",
    img: Images.Lahane,
    shortInfo: "Renowned eye surgeon",
    longInfo:
      "Dr. T. P. Lahane is a renowned eye surgeon known for his mastery in eye surgery and community work in ophthalmology in rural and tribal areas of Maharashtra. He has performed over162,000 cataract surgeries so far and treated over 10 lakh patients. He was the dean of Grant Medical College & Sir J.J. Hospital Mumbai where his dedication, determination and hard work has made the department of ophthalmology the most advanced tertiary eye care centre in Maharashtra.Dr. Lahane is a rare combination of surgical brilliance and humanitarian inclination. He was awarded the Padma Shri award in 2008, the 4th highest civilian award in India. He is currently the Director of Directorate of Medical Education and Research (DMER) in Mumbai Maharashtra",
  },
  {
    name: "Dr. Gustad B Daver",
    img: Images.Gustad,
    shortInfo: "Medical Director and Head of Surgery",
    longInfo:
      "Dr. Gustad B. Daver is the Medical Director and Head of Surgery of Sir H. N. Reliance Foundation Hospital and Research Centre. He was earlier, the Dean of Grant Medical College and Sir JJ Group of Hospitals and Professor and Head of General Surgery. Presently, he is the President of ‘Zonal Transplant Co-ordination Cell’, Mumbai, for Organ Transplant. He has contributed to the development and organisation of Multi Organ Transplant Program in the state of Maharashtra and the city of Mumbai, since 1994 when the Human Organ Transplantation ACT was introduced in India.Dr. Davar is the founder member of Vascular Society of India and Infective Disease Society of India. He is the recipient of ‘Life Time Achievement’ award for meritorious service by SEWA Social & Welfare Association and has been conferred with the ‘Best Doctor Award’ by the Indian Medical Association, Mumbai.",
  },
  {
    name: "Dr. Vijay Haribhakti",
    img: Images.Vijay,
    shortInfo: " Surgical Oncologist ",
    longInfo:
      "Dr. Vijay V. Haribhakti is a Consultant Surgical Oncologist and Microvascular and Reconstructive Surgeon, with a 30-year experience. His major areas of interest include Head and Neck Cancer, Breast Cancer, and Reconstructive surgery, and his experience spans several thousand cases with a high success rate. He is known for designing an instrument system for endoscopic assessment of the larynx, which was developed by the Karl Storz Company, Germany.Apart from numerous papers and articles, he has authored all the Head and Neck chapters of a major Oncology textbook published recently. He has also co-authored for an educative booklet published for patients with Breast Cancer and titled ‘Whispering Hope’. Dr. Haribhakti’s passion for restoring Quality of Life to one and all led him to set up a ‘Quality of Life Foundation’, which is currently active.",
  },
  {
    name: "Dr. Amita Joshi",
    img: Images.Amita,
    shortInfo:
      " Professor and Head of Department of Pathology.",
    longInfo:
      "Dr. Amita Joshi is a Professor and Head of Department of Pathology, Seth G S Medical College & K E M Hospital, Mumbai. She has 28 years of under-graduate & 25 years of post-graduate teaching experience in a large medical college & hospital of repute. Additionally, she has over 70 publications in national & international journals, presentations in conferences & guest lectures in the subject.Her special interest lies in Liver & GI pathology and has been trained for liver transplant pathology from Pittsburgh, Pennsylvania. Dr. Joshi is also a member of various academic groups such as Indian association of pathologists & microbiologists, Indian association of gastroenterology, Bombay haematology group etc.",
  },
];
  const [loading, setLoading] = useState(true);

  // ✅ useEffect instead of React.useEffect
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    },300); // loader disappears after 2s

    return () => clearTimeout(timer);
  }, []);
  
  
 

  return (
    <>
      {loading && (
        <div
          className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
          style={{ zIndex: 9999 }}
        >
          <div className="custom-spinner"></div>
        </div>
      )}

      <div>
        <section className="ul-breadcrumb ul-section-spacing">
          <div className="ul-container">
            <h2 className="ul-breadcrumb-title">
              MedEngage Summit Second Edition
            </h2>
            <ul className="ul-breadcrumb-nav">
              <li>
                <Link to="/">Home</Link>
              </li>

              <li>
                <span className="separator">
                 <i className="fa fa-arrow-right"></i>
                </span>
              </li>
              <li>MedEngage Summit 2021</li>
            </ul>
          </div>
        </section>

        <section className="ul-about ul-section-spacing ">
          <div className="ul-container">
            <div className="row row-cols-md-2 row-cols-1 align-items-center gy-4 ul-about-row">
              <div className="col">
                <div className="ul-about-txt">
                  <h2 className="ul-section-title">
                    Summit{" "}
                    <span>
                      <strong className="green">2021</strong>
                    </span>
                  </h2>

                  <p className="ul-section-descr">
                    Metropolis launched the very first edition of the “MedEngage
                    Scholarship Summit 2018” on the 9th of December in Mumbai.
                    The event was a huge success with the presence of industry
                    experts and student winners from around the country.
                    Metropolis is now coming up with the second edition of its
                    flagship scholarship event, MedEngage 2021.
                  </p>

                  <p className="ul-section-descr">
                    MEDENGAGE is an effort by Metropolis to engage and partner
                    with medical students who essentially form the future
                    way-forward, supporting world-class laboratory assistance to
                    raise the bar of academic research in the country. This is a
                    part of the company’s social initiatives to bring changes
                    and improve the healthcare research and academic landscape
                    in India.
                  </p>

                  <p className="ul-section-descr">
                    Metropolis this year, would be honouring{" "}
                    <b>70+ students with scholarships worth ₹50 lakhs</b>.
                    MedEngage program received applications from over{" "}
                    <b>400+ medical institutions</b>, and Metropolis received
                    more than <b>800 applications</b>.
                  </p>
                </div>
              </div>

              <div className="col">
                <div className="ul-about-imgs">
                  <div className="img-wrapper">
                    <iframe
                      width="100%"
                      height="315"
                      src="https://www.youtube.com/embed/qSxKs9W9FVI?autoplay=0"
                      title="Scholarship Video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      className="scholarship-video"
                    ></iframe>

                    <p className="ul-section-descr">
                      Watch the summit conducted on{" "}
                      <b>13th of February, 2021</b> as we acknowledge the
                      upcoming doctors.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="py-5 bg-dark">
          <div className="container">
            <h2 className="ul-section-title text-white text-center main-heading">
              Categories And Description Of Awards
            </h2>

            <div className="row g-4">
              {[
                {
                  img: Images.Icon1,
                  title: "Wordsmith",
                  desc: "The Wordsmith Scholarship Award is given to a deserving student who is able to skillfully articulate his thoughts into words.",
                },
                {
                  img: Images.Icon2,
                  title: "The Vibrant One",
                  desc: "The ‘Vibrant One’ Award is given to a deserving student who participates enthusiastically in extracurricular activities apart from academic brilliance.",
                },
                {
                  img: Images.Icon3,
                  title: "Scholar Collar",
                  desc: "The ‘Scholar Collar’ Award is given to a deserving student who participates enthusiastically in poster & paper presentations and consistently contributes to journals and research publications.",
                },
                {
                  img: Images.Icon4,
                  title: "WizKid",
                  desc: "The ‘WizKid’ Award is given to a deserving student who has consistently performed and delivered excellence in a particular branch of science.",
                },
                {
                  img: Images.Icon5,
                  title: "Champion of the Champion",
                  desc: "The ‘Champion of the Champion’ Award is given to a deserving student who has consistently delivered outstanding performance in academics, participated in poster, paper, journals and research publications along with pursuing other interests.",
                },
                {
                  img: Images.Icon6,
                  title: "Pedagogue",
                  desc: "The ‘Pedagogue’ Award is given to a deserving student who has consistently delivered outstanding performance in academics.",
                },
              ].map((award, index) => (
                <div key={index} className="col-12 col-sm-6 col-lg-4">
                  <div className="card h-100 bg-light text-dark shadow-sm rounded-4 p-3 d-flex flex-column flex-md-row align-items-center">
                    <img
                      src={award.img}
                      alt={award.title}
                      className="img-fluid mb-3 mb-md-0 me-md-3"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "contain",
                      }}
                    />
                    <div className="text-center text-md-start">
                      <h5 className="fw-bold mb-2">{award.title}</h5>
                      <p className="mb-0 awardcard-description">{award.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* TEAM SECTION START */}

        <section className="ul-team ul-section-spacing">
          <div className="ul-container">
            <div className="ul-section-heading justify-content-center">
              <div className="left">
                <h2 className="text-center mb-4 ul-section-title">
                  <span className="green">Jury </span> Profile 2020-21
                </h2>
              </div>
            </div>

            <div className="row g-2 g-sm-3 g-md-4 row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 ul-team-row justify-content-center">
              {teamMembers.map((member, idx) => (
                <div className="col" key={idx}>
                  <div className="ul-team-member">
                    <div className="ul-team-member-img">
                      <img src={member.img} alt={member.name} />
                    </div>
                    <div className="ul-team-member-info text-center p-3">
                      <h3 className="ul-team-member-name mb-2">
                        <span className="text-dark">{member.name}</span>
                      </h3>
                      <p className="thumb-p mb-3 doctor-info">
                        {member.shortInfo}
                      </p>

                      <button
                        className="btn btn-link text-success text-decoration-none thumb-p"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#memberModal"
                        onClick={() => setSelectedMember(member)}
                      >
                        Read More
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Beautified Bootstrap Modal */}
          <div
            className="modal fade"
            id="memberModal"
            tabIndex="-1"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content border-0 shadow-lg rounded-4">
                {selectedMember && (
                  <>
                    <div className="modal-header border-0 pb-0">
                      <h4 className="modal-title fw-bold text-success">
                        {selectedMember.name}
                      </h4>
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="modal-body text-center px-4">
                      <img
                        src={selectedMember.img}
                        alt={selectedMember.name}
                        className="img-fluid rounded-circle shadow-sm mb-4"
                        style={{
                          width: "160px",
                          height: "160px",
                          objectFit: "cover",
                        }}
                      />
                      <p className="fs-6 text-muted">
                        {selectedMember.longInfo}
                      </p>
                    </div>
                    <div className="modal-footer border-0 justify-content-center">
                      <button
                        type="button"
                        className="btn btn-outline-secondary px-4 rounded-pill"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
        {/* Bootstrap Modal */}
        <div
          className="modal fade"
          id="memberModal"
          tabIndex="-1"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content border-0 shadow-lg rounded-4">
              {selectedMember && (
                <>
                  {/* Header */}
                  <div className="modal-header border-0 pb-0">
                    <h4 className="modal-title fw-bold text-primary">
                      {selectedMember.name}
                    </h4>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>

                  {/* Body */}
                  <div className="modal-body text-center px-4">
                    <img
                      src={selectedMember.img}
                      alt={selectedMember.name}
                      className="img-fluid rounded-circle shadow-sm mb-4"
                      style={{
                        width: "160px",
                        height: "160px",
                        objectFit: "cover",
                      }}
                    />
                    <p className="fs-5 text-muted">{selectedMember.longInfo}</p>
                  </div>

                  {/* Footer */}
                  <div className="modal-footer border-0 justify-content-center">
                    <button
                      type="button"
                      className="btn btn-outline-secondary px-4 rounded-pill"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MedEngageSummit2021